<template>
  <div
    :class="template === 'Home' ? '' : 'border-r border-truegrey-100'"
    class="h-full bg-white relative flex flex-col"
  >
    <div
      class="h-24 w-full py-7 bg-no-repeat bg-center bg-contain flex items-center justify-center"
      :style="[
        { backgroundImage: 'url(' + settings.logo + ')' },
        { backgroundSize: 'calc(100% - 16px)' },
      ]"
    >
      <span class="hidden">{{ settings.profile_title }}</span>
    </div>

    <div
      class="flex items-center justify-center text-truegrey-500 hover:text-primary cursor-pointer border-t border-b border-truegrey-100 py-5 w-full"
      @click="toggleMenu"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fill-rule="evenodd"
          d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
          clip-rule="evenodd"
        />
      </svg>
    </div>

    <div
      class="flex items-center justify-center text-truegrey-500 hover:text-primary cursor-pointer border-b border-truegrey-100 py-5 w-full"
      @click="showSubscribeModal"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"
        />
        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
      </svg>
    </div>

    <!-- Admin controls -->
    <div class="mt-auto">
      <div
        v-if="user"
        class="flex items-center justify-center text-white hover:text-primary bg-primary hover:bg-white cursor-pointer py-5 w-full transition-all duration-300"
        @click="openAdminMenu"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            d="M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z"
          />
        </svg>
      </div>

      <div
        v-if="user"
        class="flex items-center justify-center text-white hover:text-primary bg-black hover:bg-white cursor-pointer py-5 w-full transition-all duration-300"
        @click="triggerLogOut"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
          />
        </svg>
      </div>

      <div
        v-if="!user"
        class="flex items-center justify-center text-white hover:text-primary bg-black hover:bg-white cursor-pointer py-5 w-full transition-all duration-300"
        @click="showLoginModal"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
          />
        </svg>
      </div>
    </div>

    <div class="hidden"></div>
  </div>
</template>

<script>
import { EventBus } from '../../../../../../js/plugins/event-bus.js'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      activeItem: 'Home',
      activeAdminMenuItem: '',
      adminMenuActive: false,
      scrolledToBottom: false,
      template: this.templateView,
      smartMenuActive: false,
    }
  },

  computed: {
    // Set all map getters
    ...mapGetters({
      settings: 'shared/getSettings',
      user: 'shared/getUser',
      templateView: 'shared/getTemplateView',
    }),
  },

  watch: {
    templateView: {
      handler: function (template) {
        this.$set(this, 'template', template)
      },

      deep: true,
    },
  },

  mounted() {
    EventBus.$on('smartMenuStateChanged', (active) => {
      this.$set(this, 'smartMenuActive', active)
    })
  },

  methods: {
    openNewPost() {
      EventBus.$emit('showModal', 'new-post')
    },

    showSubscribeModal() {
      this.$set(this, 'smartMenuActive', false)
      EventBus.$emit('showSmartMenu', this.smartMenuActive)
      EventBus.$emit('showModal', 'subscribe')
    },

    showLoginModal() {
      this.$set(this, 'smartMenuActive', false)
      EventBus.$emit('showSmartMenu', this.smartMenuActive)
      EventBus.$emit('showModal', 'login')
    },

    triggerLogOut() {
      this.$set(this, 'smartMenuActive', false)
      EventBus.$emit('showSmartMenu', this.smartMenuActive)
      EventBus.$emit('showModal', 'logout')
    },

    openAdminMenu() {
      EventBus.$emit('openAdminMenu')
      this.$set(this, 'smartMenuActive', true)
    },

    toggleMenu() {
      this.smartMenuActive = !this.smartMenuActive
      EventBus.$emit('showSmartMenu', this.smartMenuActive)
    },
  },
}
</script>
